export const primaryFont = '"SouceSansPro", sans-serif';
export const Baloo = '"Baloo 2", sans-serif';

export const typeScale = {
  header1: '1.6rem',
  header2: '1.4rem',
  header3: '1.1rem',
  regular: '1rem',
  iconLabel: '0.875rem',
  helperText: '0.8rem',
  copyrightText: '0.7rem',
};

export const fontWeight = {
  light: 400,
  primary: 500,
  semiBold: 600,
  bold: 700,
};
